// extracted by mini-css-extract-plugin
export default {"project-table":"ProjectTable_project-table__6hmiF","icon":"ProjectTable_icon__5reuE"};